import React from "react";

const OPTION_BOX_STYLE = { border: "1px solid #ddd" };
const LABEL_STYLE = {
	display: "flex",
	alignItems: "end",
	justifyContent: "end",
	fontWeight: 500,
};
const OPTION_TEXT_STYLE = {
	fontWeight: 500,
	paddingTop: "20px",
	marginLeft: "30px",
	cursor: "pointer",
};
const RADIO_LABEL_STYLE = { paddingTop: "20px", cursor: "pointer" };

const Question = ({ question, index, onSelectAnswer, selectedAnswer }) => {
	const handleOptionChange = (optionIndex, option) => {
		onSelectAnswer(index, optionIndex, option);
	};
	return (
		<div>
			<h3>
				{index + 1}. {question.question}
			</h3>
			<ul style={{ listStyle: "none", padding: 0 }}>
				{question.options.map((option, i) => {
					const label = String.fromCharCode(97 + i);
					return (
						<div
							key={i}
							style={OPTION_BOX_STYLE}
							onClick={() => handleOptionChange(i, option)}>
							<div className="row" style={{ padding: 0, cursor: "pointer" }}>
								<div className="col-1" style={LABEL_STYLE}>
									{label.toUpperCase()}.
								</div>
								<div className="col-9" style={OPTION_TEXT_STYLE}>
									{option}
								</div>
								<div className="col-1" style={LABEL_STYLE}>
									<label style={RADIO_LABEL_STYLE}>
										<input
											type="radio"
											value={option}
											name={`question-${index}`}
											checked={selectedAnswer === option}
											onChange={() => handleOptionChange(i, option)}
											style={{ cursor: "pointer" }}
										/>
									</label>
								</div>
							</div>
							<br />
						</div>
					);
				})}
			</ul>
		</div>
	);
};
export default Question;
